import {
  UseMutationOptions,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../../axiosAuth";
import { SUB_MODULE } from "../apiRoutes";

const mutateAddSubModule = async ({ data }: { data: FieldValues }) => {
  return await axiosAuth.post(SUB_MODULE, data);
};

const useAddSubModuleMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      data: FieldValues;
    },
    unknown
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: mutateAddSubModule,
    onSuccess: (data, variables, context) => {
      // Invalidate and refetch submodule queries
      queryClient.invalidateQueries({
        queryKey: ["subModule"],
        exact: false,
      });
      queryParams?.onSuccess?.(data, variables, context);
    },
    ...queryParams,
  });
};

export default useAddSubModuleMutation;
